module.exports = __webpack_public_path__ + "static/media/orang.6d6a9259.png";